module.exports = __webpack_public_path__ + "img/webcam-icon.1e003fec.svg";